export default [
  {
    path: "/qualys-auth-setup",
    name: "QualysAuthSetup",
    component: () => import("@/views/Page/QualysAuthSetup/QualysAuthSetup.vue"),
    meta: {
      title: "Qualys Auth Setup",
      requiresAuth: true,
    },
  },
];
